import { Routes } from '@angular/router';

export const publicRoutes: Routes = [
  {
    path: 'pix/:data',
    loadComponent: () => import('./pix-viewer/pix-viewer.component'),
  },
];
